export default __webpack_public_path__ + "static/media/recentTransactions.adf41b20.svg";